import React from "react";
import { Link } from "react-router-dom";
import { Icons } from "../assets/icons/Icons";

export const Footer = () => {
    return (
        <div
            id="footer-bar"
            className="footer-bar-1 footer-bar-detached w-100 custom-bottom-nav"
            style={{
                position: "sticky",
                borderRadius: "16px",
                paddingTop: "6px",
                background: "rgba(255, 255, 255, 0.05)",
                border: "1px solid rgba(255, 255, 255, 0.05)",
                backdropFilter: "blur(28.899999618530273px)",
            }}
        >
            <Link to="/mapex" className="text-center flex flex-col items-center">
                <img
                    src="images/store/footer_mapex.svg"
                    alt="mapex"
                    style={{ marginTop: "5px" }}
                />
                <span>Mapex</span>
            </Link>
            <Link to="/plans" className="text-center flex flex-col items-center">
                <img
                    src="images/store/footer_plans.svg"
                    alt="plans"
                    style={{ marginTop: "2px" }}
                />
                <span>Plans</span>
            </Link>
            <Link
                to="/"
                className="circle-nav-2"
                style={{ width: "68px", height: "68px" }}
            >
                <img
                    src="images/store/footer_home.svg"
                    alt="home"
                    className="mx-auto"
                    style={{ marginTop: "-42px" }}
                />
                <span className="" style={{ marginTop: "1px" }}>
                    Home
                </span>
            </Link>
            <Link to="/cards" className="text-center flex flex-col items-center">
                <img
                    src="images/store/footer_cards.svg"
                    alt="plans"
                    style={{ marginTop: "2px" }}
                />
                <span>Cards</span>
            </Link>
            <Link
                to="#"
                data-bs-toggle="offcanvas"
                data-bs-target="#menu-sidebar"
                style={{ marginTop: "0px" }}
            >
                <i className="bi bi-three-dots"></i>
                <span>More</span>
            </Link>

            <div className="d-flex justify-content-center mt-3">
                <Link
                    to={"/activity"}
                    className="font-13 font-600 pt-1"
                    style={{
                        background: "rgba(0, 0, 0, 0.58)",
                        width: "100%",
                        height: "70px",
                        position: "absolute",
                        bottom: "-70px",
                        left: "0px",
                        zIndex: "1",
                    }}
                ></Link>
            </div>
        </div>

        // <div
        //     id="footer-bar"
        //     className="footer-bar-1 footer-bar-detached w-100 custom-bottom-nav"
        //     style={{
        //         position: "sticky",
        //         borderRadius: "16px",
        //         paddingTop: "6px",
        //     }}
        // >
        //     <Link
        //         to="/mapex"
        //         style={{
        //             display: "flex",
        //             flexDirection: "column",
        //             alignItems: "center",
        //             textDecoration: "none",
        //             width: "20%",
        //         }}
        //     >
        //         <Icons.MapexHomeIcon />
        //         <span
        //             className="text-white"
        //             style={{ fontSize: "12px", marginTop: "4px" }}
        //         >
        //             Mapex
        //         </span>
        //     </Link>

        //     <Link
        //         to="/plans"
        //         style={{
        //             display: "flex",
        //             flexDirection: "column",
        //             alignItems: "center",
        //             textDecoration: "none",
        //             width: "20%",
        //         }}
        //     >
        //         <img
        //             src="images/store/footer_plans.png"
        //             alt="plans"
        //             style={{ height: "24px" }}
        //         />
        //         <span style={{ fontSize: "12px", marginTop: "4px" }}>
        //             Plans
        //         </span>
        //     </Link>

        //     <Link
        //         to="/"
        //         style={{
        //             display: "flex",
        //             flexDirection: "column",
        //             alignItems: "center",
        //             textDecoration: "none",
        //             width: "20%",
        //             marginTop: "-40px",
        //         }}
        //     >
        //         <div
        //             style={{
        //                 backgroundColor: "#3A36D5",
        //                 width: "60px",
        //                 height: "60px",
        //                 borderRadius: "50%",
        //                 display: "flex",
        //                 alignItems: "center",
        //                 justifyContent: "center",
        //             }}
        //         >
        //             {/* <img
        //                 src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Group%20412-m4oMaLZwU8XKI14Pj4Nw5S5MM9qhJo.png"
        //                 alt="Home"
        //                 style={{ width: "28px", height: "28px" }}
        //             /> */}
        //             <Icons.AccountHomeIcon />
        //         </div>
        //         <span style={{ fontSize: "12px", marginTop: "8px" }}>Home</span>
        //     </Link>

        //     <Link
        //         to="/cards"
        //         style={{
        //             display: "flex",
        //             flexDirection: "column",
        //             alignItems: "center",
        //             textDecoration: "none",
        //             width: "20%",
        //         }}
        //     >
        //         <img
        //             src="images/store/footer_cards.png"
        //             alt="cards"
        //             style={{ height: "24px" }}
        //         />
        //         <span style={{ fontSize: "12px", marginTop: "4px" }}>
        //             Cards
        //         </span>
        //     </Link>

        //     <Link
        //         to="#"
        //         data-bs-toggle="offcanvas"
        //         data-bs-target="#menu-sidebar"
        //         style={{
        //             display: "flex",
        //             flexDirection: "column",
        //             alignItems: "center",
        //             textDecoration: "none",
        //             width: "20%",
        //         }}
        //     >
        //         <i
        //             className="bi bi-three-dots"
        //             style={{ fontSize: "24px" }}
        //         ></i>
        //         <span style={{ fontSize: "12px", marginTop: "4px" }}>More</span>
        //     </Link>
        // </div>
    );
};

// <div
//     id="footer-bar"
//     className="footer-bar-1 footer-bar-detached w-100 custom-bottom-nav"
//     style={{
//         position: "sticky",
//         borderRadius: "16px",
//         paddingTop: "6px",
//     }}
// >
//     <Link
//         to="/mapex"
//         style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             textDecoration: "none",
//             width: "20%",
//         }}
//     >
//         <Icons.MapexHomeIcon />
//         <span
//             className="text-white"
//             style={{ fontSize: "12px", marginTop: "4px" }}
//         >
//             Mapex
//         </span>
//     </Link>

//     <Link
//         to="/plans"
//         style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             textDecoration: "none",
//             width: "20%",
//         }}
//     >
//         <img
//             src="images/store/footer_plans.png"
//             alt="plans"
//             style={{ height: "24px" }}
//         />
//         <span style={{ fontSize: "12px", marginTop: "4px" }}>Plans</span>
//     </Link>

//     <Link
//         to="/"
//         style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             textDecoration: "none",
//             width: "20%",
//             marginTop: "-40px",
//         }}
//     >
//         <div
//             style={{
//                 backgroundColor: "#3A36D5",
//                 width: "60px",
//                 height: "60px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//             }}
//         >
//             {/* <img
//                         src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Group%20412-m4oMaLZwU8XKI14Pj4Nw5S5MM9qhJo.png"
//                         alt="Home"
//                         style={{ width: "28px", height: "28px" }}
//                     /> */}
//             <Icons.AccountHomeIcon />
//         </div>
//         <span style={{ fontSize: "12px", marginTop: "8px" }}>Home</span>
//     </Link>

//     <Link
//         to="/cards"
//         style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             textDecoration: "none",
//             width: "20%",
//         }}
//     >
//         <img
//             src="images/store/footer_cards.png"
//             alt="cards"
//             style={{ height: "24px" }}
//         />
//         <span style={{ fontSize: "12px", marginTop: "4px" }}>Cards</span>
//     </Link>

//     <Link
//         to="#"
//         data-bs-toggle="offcanvas"
//         data-bs-target="#menu-sidebar"
//         style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             textDecoration: "none",
//             width: "20%",
//         }}
//     >
//         <i className="bi bi-three-dots" style={{ fontSize: "24px" }}></i>
//         <span style={{ fontSize: "12px", marginTop: "4px" }}>More</span>
//     </Link>
// </div>;
